import React, { useMemo } from 'react';

import classNames from 'classnames';

import { useCurrentNode } from '../CurrentNodeProvider';
import KeyboardHints from '../KeyboardHints';
import { SIDEBAR_HINT_COUNT, getKeyboardHints } from '../keyboard';

import SectionsNav from './SectionsNav';
import SectionTree from './SectionTree';

type WikiSidebarProps = {
  className?: string;
  hasKeyboardHints?: boolean;
};

const WikiSidebar = ({ className, hasKeyboardHints = false }: WikiSidebarProps) => {
  const node = useCurrentNode();
  const hints = useMemo(() => getKeyboardHints().slice(0, SIDEBAR_HINT_COUNT), []);

  return (
    <div className={classNames('flex flex-col gap-6', className)}>
      <SectionsNav node={node} />
      <SectionTree node={node} />
      {hasKeyboardHints && (
        <KeyboardHints
          className="mt-auto border-t border-gray-200 px-2 pt-4 dark:border-gray-800"
          hints={hints} />
      )}
    </div>
  );
};

export default WikiSidebar;
